import React from "react";
import WeatherIcon from "./WeatherIcon";

export default function WeatherForecastDay(props) {
  function maxTemp() {
    let temp = Math.round(props.data.temp.max);
    return `${temp}`;
  }

  function minTemp() {
    let temp = Math.round(props.data.temp.min);
    return `${temp}`;
  }

  function day() {
    let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    let date = new Date(props.data.dt * 1000).getDay();
    return days[date];
  }

  return (
    <div>
      <div className="WeatherForecastDay">{day()}</div>
      <WeatherIcon
        iconName={props.data.weather[0].icon}
        size={30}
        color="gold"
      />
      <div className="WeatherForecastTemp">
        <span className="WeatherForecastTempMax">{maxTemp()}˚</span>
        <span className="WeatherForecastTempMin">{minTemp()}˚</span>
      </div>
    </div>
  );
}
